import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { languageCodeZodSchema } from "@@/shared/translations/language-code";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const translateCommandResponseZodObject = z.object({
    _id: z.string(),
    _type: z.literal("TRANSLATE_COMMAND_RESPONSE"),
    _createdAt: isoAndUnixZodSchema,
    originalText: z.string(),
    result: z.string(),
    from: languageCodeZodSchema,
    to: languageCodeZodSchema,
    providerId: providerIdZodSchema.optional(),
});

type TranslateCommandResponse = z.infer<
    typeof translateCommandResponseZodObject
>;

const translateCommandResponseFactoryParamsZodObject =
    translateCommandResponseZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

type TranslateCommandResponseFactoryParams = z.infer<
    typeof translateCommandResponseFactoryParamsZodObject
>;
const translateCommandResponseFactory = (
    params: TranslateCommandResponseFactoryParams,
): TranslateCommandResponse => {
    return {
        _id: generateId({ prefix: "translate_command_response__" }),
        _type: "TRANSLATE_COMMAND_RESPONSE",
        _createdAt: nowIsoAndUnix(),
        ...params,
    };
};

export {
    translateCommandResponseFactory,
    translateCommandResponseFactoryParamsZodObject,
    translateCommandResponseZodObject,
};
export type { TranslateCommandResponse, TranslateCommandResponseFactoryParams };
